// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import QqSquareFilledSvg from "@ant-design/icons-svg/es/asn/QqSquareFilled";
import AntdIcon from '../components/AntdIcon';

var QqSquareFilled = function QqSquareFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: QqSquareFilledSvg
  }));
};

QqSquareFilled.displayName = 'QqSquareFilled';
export default React.forwardRef(QqSquareFilled);